export default __webpack_public_path__ + "static/media/Logo.756a4d9a.svg";